(() => {
  if (window.ibProductDepth) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const records = new Map();
  const visible = new Set();
  let frame = 0;
  const selectors = '.ibr-card-image img, .ibcg-image img, .ibp-art img, .ibpp-gallery img, .product__media img';
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
    schedule();
  }, { rootMargin: '60px', threshold: 0 });
  const waveObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('ib-wave-visible', entry.isIntersecting));
  }, { rootMargin: '30px', threshold: 0 });
  function schedule() {
    if (!frame && !motion.matches && !document.hidden) frame = requestAnimationFrame(update);
  }
  function update() {
    frame = 0;
    const height = window.innerHeight;
    const values = [];
    visible.forEach(img => {
      if (!img.isConnected) { visible.delete(img); records.delete(img); observer.unobserve(img); return; }
      const rect = img.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - height / 2) / (height / 2 + rect.height / 2)));
      const center = 1 - Math.abs(progress);
      const direction = records.get(img) || 1;
      values.push([img, progress, center, direction]);
    });
    values.forEach(([img, progress, center, direction]) => {
      img.style.setProperty('--ib-depth-x', `${(-progress * 6).toFixed(2)}deg`);
      img.style.setProperty('--ib-depth-y', `${(progress * direction * 5).toFixed(2)}deg`);
      img.style.setProperty('--ib-depth-shift', `${(-progress * 8).toFixed(2)}px`);
      img.style.setProperty('--ib-depth-scale', (0.97 + center * 0.045).toFixed(3));
    });
  }
  function init(root = document) {
    root.querySelectorAll(selectors).forEach((img, index) => {
      if (records.has(img)) return;
      records.set(img, index % 2 ? -1 : 1);
      img.classList.add('ib-depth-image');
      img.parentElement.classList.add('ib-product-depth');
      observer.observe(img);
    });
    root.querySelectorAll('.ib-footer-motion').forEach(el => {
      waveObserver.observe(el);
      const button = el.querySelector('[data-footer-motion-toggle]');
      if (!button || button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const paused = el.dataset.paused !== 'true';
        el.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      });
    });
    schedule();
  }
  function reset() {
    if (motion.matches) {
      cancelAnimationFrame(frame); frame = 0;
      records.forEach((_, img) => ['--ib-depth-x', '--ib-depth-y', '--ib-depth-shift', '--ib-depth-scale'].forEach(name => img.style.removeProperty(name)));
    } else schedule();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('visibilitychange', () => {
    document.documentElement.classList.toggle('ib-motion-hidden', document.hidden);
    if (document.hidden) { cancelAnimationFrame(frame); frame = 0; } else schedule();
  });
  motion.addEventListener('change', reset);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => {
    records.forEach((_, img) => { if (!img.isConnected) { observer.unobserve(img); visible.delete(img); records.delete(img); } });
  });
  document.addEventListener('shopify:section:select', () => document.querySelectorAll('.ib-footer-motion').forEach(el => el.classList.add('ib-wave-visible')));
  window.ibProductDepth = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
})();
